import { MultiSelect } from '@empathy/search-types';
import { DeepPartial, Dictionary } from '../../../utils';
import { LayoutDirection, SlidingDirection } from '../interfaces';
import { FacetsGroupSlots, FacetSlots, TemplateSlots } from './slots.const';

export enum ShowSelectedFilters {
  WhenCollapsed = 'WhenCollapsed',
  WhenExpanded = 'WhenExpanded',
  Always = 'Always',
  Never = 'Never'
}

export interface FacetsConfig {
  default: {
    facet: FacetConfig
    group: FacetsGroupConfig,
  };
  facets?: NamedFacetsConfig;
  groups: FacetsGroupsConfig;
}

export type FacetsGroupsConfig = Dictionary<DeepPartial<FacetsGroupConfig>>;
export type NamedFacetsConfig = Dictionary<DeepPartial<FacetConfig>>;

export interface FacetsGroupConfig {
  addRemainingFacets: boolean;
  collapsible: boolean;
  components: {
    panel: string;
    close: string;
    clear: string;
    clearIcon?: string;
    toggle: string;
    toggleIcon?: string;
    selectedFilters: {
      selectedFilters: string;
      removeIcon: string;
    }
    header: string;
    footer: string;
  };
  excludeFromRemainingFacets: string[];
  facets?: {
    [facetName: string]: DeepPartial<FacetInGroupConfig>
  };
  layoutDirection: LayoutDirection;
  slidingDirection: SlidingDirection;
  slots: {
    close: FacetsGroupSlots | string;
    clear: FacetsGroupSlots | string;
    selectedFilters: FacetsGroupSlots | string;
  };
  startCollapsed: boolean;
  templateSlots: {
    panel: TemplateSlots | string;
    toggle: TemplateSlots | string;
  };
}

export interface FacetConfig {
  collapsible: boolean;
  components: {
    facet: string;
    selectedFilters: {
      selectedFilters: string;
      filterTitle: string;
      removeIcon: string;
    },
    beforeFilters: string;
    facetSearch: {
      search: string;
      icon: string;
      clear: string;
    };
    filters: string; // This component is used to replace the whole filters of a facet. If set to anything different that null, it will
    // disable the filter property of this same interface.
    filter: {
      filter: string;
      checkbox: string;
      title: string;
    }
    icon: string;
    header: string;
    footer: string;
  };
  filtersToShow: number;
  mapping: {
    filterModelName: string;
    multiSelectable: MultiSelect;
    isDynamic: boolean;
    showUnselectedValues: boolean;
  };
  searchable: {
    enabled: boolean;
    toggleable: boolean;
    startsOpen: boolean;
    facetsFilterRegex: string;
  };
  showMoreButton: boolean;
  showSelectedFilters: ShowSelectedFilters;
  slots: {
    selectedFilters: FacetSlots | string;
  };
  startCollapsed: boolean;
  compulsory: boolean;
  renderChildren: boolean;
  useIndexAsFilterKey: boolean;
}

export type FacetInGroupConfig = Omit<FacetConfig, 'mapping'>;
